// DATA
// button > id / isLast 필수

/**
 * action (next | finish | route | hintView)
 * next: 다음 채팅으로 이동 (onFinish 미사용)
 * finish: 게임 종료 (onFinish 필요)
 * route: 페이지 이동 (onFinish 필요, useNavigate)
 */

import s1_itemA from "../../img/quiz/s1_itemA.png"; // [X]code01
import s3_itemA from "../../img/quiz/s3_itemA.png"; // [X]time03
import s3_itemB from "../../img/quiz/s3_itemB.png"; // [Y]time03
import s4_itemA from "../../img/quiz/s4_itemA.png"; // [X]TRACE4
import s6_itemA from "../../img/quiz/s6_itemA.png"; // [X]FILE06
import s7_itemA from "../../img/quiz/s7_itemA.png"; // [X]LANG07
import s7_itemB from "../../img/quiz/s7_itemB.png"; // [Y]LANG07

export const CHAT_DATA = {
  intro1: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: `
        [긴급]<br/>기업 기밀 유출 위험 발생!
      `,
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `
        우리 회사 안에 <span class="txtW700">스파이 X</span>가 숨어 있다는 비밀 정보가 들어왔습니다.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        스파이 X는 회사 직원처럼 위장해 있어요.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        단서를 모아야만 정체를 밝힐 수 있는데, <span class="txtW700">모든 단서는 두 사람이 힘을 합쳐야만 열 수 있는 이중 장치</span>로 되어 있습니다.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        미션을 성공할 때마다 스파이에 대한 <span class="txtW700">단서 하나</span>를 얻을 수 있습니다.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        단서를 모아 용의자를 줄이고, 마지막에는 <span class="txtW700">함께 토의해 스파이 X가 누군지 밝혀내야 합니다.</span>
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        이 게임은 <span class="txtW700">2명이 협력해서 플레이</span>해야 합니다. 혼자서는 절대 풀 수 없습니다.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        모바일 웹 페이지를 이탈하거나 종료하면 게임이 처음부터 다시 시작됩니다.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        키워드를 찾아 입력하면 미션을 풀 수 있습니다.
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "네 알겠습니다",
      isLast: true,
      action: "route", // next | finish | route
      route: "/tutorial",
    },
  ],
  intro2: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk",
      text: `
        안녕, {{playerName}} 요원!<br/>
        나는 미스터리 사건을 해결하는 모다 탐정 사무소의 선임 탐정 ‘꼬네’라고 한다냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        {{playerName}} 요원은 이제 <span class="txtW700">{{playerRole}}로 회사에 잠입해 SPY X를 찾아내야 한다냥.</span>
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        이번 사건은 복잡하다냥.<br/>
        용의자 5명 모두 수상한 정황이 있다냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        나는 너희에게 <span class="txtW700">조언</span>만 줄 수 있다냥. 결정은 너희 몫이다냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        <span class="txtW700">10개의 미션</span>을 풀어 <span class="txtW700">단서</span>를 꼼꼼히 수집하고, 섣부른 판단은 피하라냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        용의자 프로파일과 수집한 단서들은 상단의 <span class="txtW700">단서 보관 상자</span>를 클릭하면 확인할 수 있다냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        그럼, SPY X를 찾으러 가보자냥!
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        <span class="txtW700 txt44BAD1">첫 추리 키워드</span>를 입력하세요.
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "추리 키워드 입력하기",
      isLast: true,
      action: "route", // next | finish | route
      route: "/keywordInput", // action === "route" 일 때
    },
  ],
  //Keyword_Code
  keyword: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: `
        고양이탐정 꼬네에게<br/>
        알맞은 키워드를 검색하세요.
      `,
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk",
      text: `
       <span class="txtW700">추리 키워드</span>를 찾아 입력하면 단서를 찾을 수 있다냥!
      `,
    },
    {
      type: "scroll",
    },
  ],
  code01: {
    agentX: [
      {
        type: "chatInfo_Talk1",
        marType: "mb20",
        text: `
          암호 해독실에 도착하니 시스템 메시지가 보인다.
        `,
      },
      {
        type: "ImgOnly",
        marType: "mb20",
        className: "chatFullImg",
        src: s1_itemA,
      },
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "system",
        chat_tit: "시스템",
        talkType: "chat_b_left_Talk",
        text: `
          지시사항: 파트너의 숫자를 이 표로 변환하세요.
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "입력 완료",
        isLast: true,
        action: "route",
        route: "/answer",
      },
    ],
    agentY: [
      {
        type: "chatInfo_Talk1",
        marType: "mb20",
        text: `
          암호 해독실에 도착하니 시스템 메시지가 보인다.
        `,
      },
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "system",
        chat_tit: "시스템",
        talkType: "chat_b_left_Talk",
        text: `
          [서버에서 발견된 암호문]  20-15-13-15-18-18-15-23
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          힌트: "내일"을 뜻하는 영어 단어
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          지시사항: 파트너와 함께 각 숫자를 알파벳으로 변환하세요.
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "입력 완료",
        isLast: true,
        action: "route",
        route: "/answer",
      },
    ],
    answer: [
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "Cone",
        chat_tit: "꼬네",
        talkType: "chat_b_left_Talk2",
        text: `
        정답이다냥~!
      `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          정답 : TOMORROW (내일)
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          변환 과정: <br/>
          20 → T (알파벳 20번째) <br/>
          15 → O <br/>
          13 → M <br/>
          15 → O <br/>
          18 → R <br/>
          18 → R <br/>
          15 → O <br/>
          23 → W
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          <p class="txtW700 txt44BAD1">단서 획득 #1</p>
          암호문: "TOMORROW" (내일)<br/>
          사용 언어: 영어<br/>
          <br/>
          분석: 범인은 영어를 능숙하게 사용함. 업무에서 영어를 자주 쓰는 사람일 가능성.
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          영어 암호문이 발견됐다냥.<br/>
          해외 경험이 있는 사람일 가능성이 있다냥. 하지만 영어는 많은 사람이 할 수 있으니 이것만으론 단정할 수 없다냥.<br/>
          더 많은 단서가 필요하다냥.
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          다음 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥.
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "확인",
        isLast: true,
        action: "route",
        route: "/keywordInput",
      },
    ],
  },
  time02: {
    agentX: [
      {
        type: "chatInfo_Talk1",
        marType: "mb20",
        text: `
          야근 기록을 조회하니 시스템 메시지가 보인다.
        `,
      },
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "system",
        chat_tit: "시스템",
        talkType: "chat_b_left_Talk",
        text: `
          [최근 1개월 야근 기록]<br/>
          각팀 별 최다 야근 횟수: <br/>
          Y회, V회, P회, I회, W회
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          Q. 가장 많이 야근한 사람의 횟수는?
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "입력 완료",
        isLast: true,
        action: "route",
        route: "/answer",
      },
    ],
    agentY: [
      {
        type: "chatInfo_Talk1",
        marType: "mb20",
        text: `
          야근 기록을 조회하니 시스템 메시지가 보인다.
        `,
      },
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "system",
        chat_tit: "시스템",
        talkType: "chat_b_left_Talk",
        text: `
          [야근 패턴 힌트]<br/>
          A = 26, B = 25 ... Z = 1
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          조건:
          <p class="indentNum">1. 보안팀 직원은 야근을 한달에 4회</p>
          <p class="indentNum">2. 11월 인사평가 때문에 야근한 사람은 11회</p>
          <p class="indentNum">3. 가장 많이 야근한 사람은 연구개발팀 직원</p>
          <p class="indentNum">4. 해외사업팀은 5회 미만</p>
          <p class="indentNum">5. 기획팀은 해외사업팀보다 많고 인사팀보다 적음</p>
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "입력 완료",
        isLast: true,
        action: "route",
        route: "/answer",
      },
    ],
    answer: [
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "Cone",
        chat_tit: "꼬네",
        talkType: "chat_b_left_Talk2",
        text: `
        정답이다냥~!
      `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          정답 : 18회
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          <p class="txtW700">[알파벳 역순 배치표]</p>
          A=26, B=25, C=24, D=23, E=22, F=21, G=20, H=19, I=18, J=17, K=16, L=15, M=14, N=13, O=12, P=11, Q=10, R=9, S=8, T=7, U=6, V=5, W=4, X=3, Y=2, Z=1
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          <p class="indentNum">1. I회 = 18회</p>
          <p class="indentNum">2. 가장 많이 야근한 사람은 연구개발팀 직원</p>
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          <p class="txtW700 txt44BAD1">단서 획득 #2</p>
          최다 야근 기록: 18회 (한 달 기준)<br/>
          <p class="txtW700">[분석]</p>
          이 사람은 한 달 내내 고르게 야근함. 특별한 시즌이나 이유 없이 지속적으로 야근.<br/>
          <p class="txtW700">[비교]</p>
          - 12회 야근자: 11월 인사평가 시즌이라 집중 야근- 18회 야근자: 명확한 이유 없이 계속 야근<br/>
          <p class="txtW700">[의문]</p>
          18회 야근의 진짜 이유는 무엇인가?
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          야근 기록에 특이한 점이 있다냥.<br/>
          18회 야근은 정상적인 업무량을 크게 넘는 수치다냥.<br/>
          야근의 진짜 이유는 무엇일까?
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          다음 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥.
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "확인",
        isLast: true,
        action: "route",
        route: "/keywordInput",
      },
    ],
  },
  time03: {
    agentX: [
      {
        type: "chatInfo_Talk1",
        marType: "mb20",
        text: `
          범죄 현장 위치를 찾기 위해 <br/>
          사무실 평면도를 보니 시스템 메시지가 보인다.
        `,
      },
      {
        type: "ImgOnly",
        marType: "mb20",
        className: "chatFullImg",
        src: s3_itemA,
      },
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "system",
        chat_tit: "시스템",
        talkType: "chat_b_left_Talk",
        text: `
          목격자 증언:<br/>
          "남쪽 복도를 지나 북쪽 복도로 갔을 때, 서쪽 첫 번째 방에서 소리가 들렸어요."
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          Q. 사건 현장은 어디인가요?
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "입력 완료",
        isLast: true,
        action: "route",
        route: "/answer",
      },
    ],
    agentY: [
      {
        type: "chatInfo_Talk1",
        marType: "mb20",
        text: `
          범죄 현장 위치를 찾기 위해<br/>
          사무실 평면도를 보니 시스템 메시지가 보인다.
        `,
      },
      {
        type: "ImgOnly",
        marType: "mb20",
        className: "chatFullImg",
        src: s3_itemB,
      },
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "system",
        chat_tit: "시스템",
        talkType: "chat_b_left_Talk",
        text: `
          Q. 사건 현장은 어디인가요?
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "입력 완료",
        isLast: true,
        action: "route",
        route: "/answer",
      },
    ],
    answer: [
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "Cone",
        chat_tit: "꼬네",
        talkType: "chat_b_left_Talk2",
        text: `
        정답이다냥~!
      `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          정답 : A (회의실)
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          "복도(H) → 북쪽(B) → 서쪽에서 1번째"
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          "남쪽 복도를 지나 북쪽 복도로 갔을 때, 서쪽 첫 번째 방에서 소리가 들렸어요."
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          <p class="txtW700 txt44BAD1">단서 획득 #3</p>
          범죄 현장: 회의실
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          결정적인 범죄는 회의실에서 일어났다냥!<br/>
          다음 장소로 이동하자냥!
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          다음 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥.
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "확인",
        isLast: true,
        action: "route",
        route: "/keywordInput",
      },
    ],
  },
  trace4: {
    agentX: [
      {
        type: "chatInfo_Talk1",
        marType: "mb20",
        text: `
          녹음 파일을 찾으니 시스템 메시지가 보인다.
        `,
      },
      {
        type: "ImgOnly",
        marType: "mb20",
        className: "chatFullImg",
        src: s4_itemA,
      },
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "system",
        chat_tit: "시스템",
        talkType: "chat_b_left_Talk",
        text: `
          스파이의 것으로 추정되는 녹음 파일에서 위와 같은 음이 연주됨
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          흩어진 조각<br/>
          조각 1: 치<br/>
          조각 2: 샵<br/>
          조각 3: 일
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          Q. 스파이 X는 회사 근처에서 <br/>
          기밀 정보를 공유했다.<br/>
          그곳은 어디일까?
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "입력 완료",
        isLast: true,
        action: "route",
        route: "/answer",
      },
    ],
    agentY: [
      {
        type: "chatInfo_Talk1",
        marType: "mb20",
        text: `
          녹음 파일을 찾으니 시스템 메시지가 보인다.
        `,
      },
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "system",
        chat_tit: "시스템",
        talkType: "chat_b_left_Talk",
        text: `
          음계를 숫자로:<br/>
          E=5, C=3, F=6, G=7, B=2
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          흩어진 조각<br/>
          조각 4: 킨<br/>
          조각 5: 네<br/>
          조각 6: 아<br/>
          조각 7: 트
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          Q. 스파이 X는 회사 근처에서 <br/>
          기밀 정보를 공유했다.
          그곳은 어디일까?
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "입력 완료",
        isLast: true,
        action: "route",
        route: "/answer",
      },
    ],
    answer: [
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "Cone",
        chat_tit: "꼬네",
        talkType: "chat_b_left_Talk2",
        text: `
        정답이다냥~!
      `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          정답 : 네일아트샵
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          <p class="indentNum">음계를 숫자로 변환 E=5, C=3, F=6, G=7, B=2</p>
          <p class="indentNum">흩어진 조각 확인 조각 5: 네 조각 3: 일 조각 6: 아 조각 7: 트 조각 2: 샵</p>
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          <p class="txtW700 txt44BAD1">단서 획득 #4</p>
          스파이X는 회사 근처 네일아트샵에서 기밀 정보를 공유했다. <br/>
          사건현장에 손톱 부스러기가 있는 것을 추가로 발견했다.
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          흥미로운 흔적들이다냥.<br/>
          스파이X는 회사 근처 네일아트샵에서 기밀 정보를 공유했다냥.<br/>
          또한 사건현장에 손톱 부스러기가 있는 것을 추가로 발견했다냥.
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          아마도 범인은 평소에 네일아트샵에 가는 것이 이상하지 않을 복선을 미리 마련했을 것으로 추정된다냥.
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          다음 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥.
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "확인",
        isLast: true,
        action: "route",
        route: "/keywordInput",
      },
    ],
  },
  mind05: {
    agentX: [
      {
        type: "chatInfo_Talk1",
        marType: "mb20",
        text: `
          상담 일지를 찾으니 시스템 메시지가 보인다.
        `,
      },
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "system",
        chat_tit: "시스템",
        talkType: "chat_b_left_Talk",
        text: `
          [심리 상담 기록]<br/>
          상담 일지:<br/>
          - 10월 1일~21일: 매주 월요일 상담 (4회)<br/>
          - 10월 28일: 5회차 예약<br/>
          - 상담 취소: 10월 ?? 일
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          동료 증언:<br/>
          "그 사람은 프로젝트에서 빠진 후 2주간 우울했는데, 10월 마지막 주부터 갑자기 밝아졌어요."
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          Q. 10월 며칠에 상담을 취소했나요?<br/>
          10월 [&nbsp;&nbsp;] 일
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "입력 완료",
        isLast: true,
        action: "route",
        route: "/answer",
      },
    ],
    agentY: [
      {
        type: "chatInfo_Talk1",
        marType: "mb20",
        text: `
          상담 일지를 찾으니 시스템 메시지가 보인다.
        `,
      },
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "system",
        chat_tit: "시스템",
        talkType: "chat_b_left_Talk",
        text: `
          [감정 변화 타임라인]<br/>
          10월 1주: 프로젝트 제외 통보 → 우울 시작<br/>
          10월 2주: 계속 우울 상태<br/>
          10월 3주: 심한 우울 (동료 증언)<br/>
          10월 4주: 갑자기 밝아짐 (10월 25일경)
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          [상담 예약 패턴]<br/>
          매주 월요일 (7일 간격)<br/>
          10월 7, 14, 21일 → 다음은 10월 28일
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          Q. 10월 며칠에 상담을 취소했나요?<br/>
          10월 [&nbsp;&nbsp;] 일
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "입력 완료",
        isLast: true,
        action: "route",
        route: "/answer",
      },
    ],
    answer: [
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "Cone",
        chat_tit: "꼬네",
        talkType: "chat_b_left_Talk2",
        text: `
        정답이다냥~!
      `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          정답 : 10월 25일
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          <p class="txtW700">[타임라인 정리]</p>
          10월 7일(월): 1회 상담 ✓<br/>
          10월 14일(월): 2회 상담 ✓<br/>
          10월 21일(월): 3회 상담 ✓<br/>
          10월 28일(월): 4회 예약... 취소됨
          <p class="txtW700">[감정 변화]</p>
          10월 1~21일: 우울 상태<br/>
          10월 25일: 갑자기 밝아짐<br/>
          10월 28일: 상담 불참
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          <p class="txtW700 txt44BAD1">단서 획득 #5</p>
          <p class="txtW700">[결정적 전환점]</p>
          10월 25일: 감정 급변<br/>
          → 이날 무언가 중대한 결심<br/>
          → "인정받는 다른 방법"을 찾음
          <p class="txtW700">[사건 발생]</p>
          11월 8일 → 10월 25일부터<br/>
          2주간 준비 기간
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          감정의 변화가 수상하다냥.<br/>
          상황은 안 좋은데 기분이 좋아졌다는 건... 뭔가 변화가 생겼다는 뜻이다냥.
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          좋은 방향일 수도, 위험한 방향일 수도 있다냥. 1주일 전이라는 시점을 기억하라냥. 뭔가 결정적인 일이 있었을 수 있다냥.
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          다음 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥.
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "확인",
        isLast: true,
        action: "route",
        route: "/keywordInput",
      },
    ],
  },
  file06: {
    agentX: [
      {
        type: "chatInfo_Talk1",
        marType: "mb20",
        text: `
          파일 접근 로그를 보니 시스템 메시지가 보인다.
        `,
      },
      {
        type: "ImgOnly",
        marType: "mb20",
        className: "chatFullImg",
        src: s6_itemA,
      },
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "system",
        chat_tit: "시스템",
        talkType: "chat_b_left_Talk2",
        text: `
          마지막 접근 종료: 20:20
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          Q. 세 번째 접근자의 작업 시간은 몇 분?
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "입력 완료",
        isLast: true,
        action: "route",
        route: "/answer",
      },
    ],
    agentY: [
      {
        type: "chatInfo_Talk1",
        marType: "mb20",
        text: `
          파일 접근 로그를 보니 시스템 메시지가 보인다.
        `,
      },
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "system",
        chat_tit: "시스템",
        talkType: "chat_b_left_Talk",
        text: `
          [접근자 정보]<br/>
          김현수:<br/>
          - 접근 사유: 해외시장 검토<br/>
          - 권한: 정상<br/>
          - 10분 = 일반적 확인 시간
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          정우석:<br/>
          - 접근 사유: 기획안 참고<br/>
          - 권한: 정상<br/>
          - 15분 = 시장분석 자료 복사
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          세 번째 접근자:<br/>
          - 프로젝트에서 제외된 상태<br/>
          - 과거 권한 회수 안됨 (실수)<br/>
          - 접근 사유: 없음<br/>
          - 19:35 시작 → 20:20 종료
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          Q. 세 번째 접근자의 작업 시간은 몇 분?
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "입력 완료",
        isLast: true,
        action: "route",
        route: "/answer",
      },
    ],
    answer: [
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "Cone",
        chat_tit: "꼬네",
        talkType: "chat_b_left_Talk2",
        text: `
        정답이다냥~!
      `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          정답 : 45분
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          <p class="txtW700">[시간 계산]</p>
          시작: 19:35<br/>
          종료: 20:20<br/>
          ─────────<br/>
          20:20 - 19:35 = ?<br/>
          <br/>
          <p class="txtW700">방법 1: 시간 변환</p>
          19:35 = 19시간 35분<br/>
          20:20 = 20시간 20분<br/>
          ─────────<br/>
          차이 = 0시간 45분 = 45분<br/>
          <br/>
          <p class="txtW700">방법 2: 단계별</p>
          19:35 → 20:00 = 25분<br/>
          20:00 → 20:20 = 20분<br/>
          ─────────<br/>
          합계 = 45분
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          <p class="txtW700 txt44BAD1">단서 획득 #6</p>
          <p class="txtW700">[45분의 비밀]</p>
          작업 시간: 45분 시작<br/>
          시각: 19:35 (대부분 퇴근 후)<br/>
          <br/>
          이 시간이면 가능한 작업:<br/>
          ✓ 파일 전체 복사<br/>
          ✓ 내용 분석 및 편집<br/>
          ✓ 외부 전송 준비
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          45분은 긴 시간이다냥.<br/>
          그리고 프로젝트에서 빠진 상태인데 접근한 것도 수상하다냥.<br/>
          수상한 포인트를 기억해두라냥.
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          다음 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥.
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "확인",
        isLast: true,
        action: "route",
        route: "/keywordInput",
      },
    ],
  },
  lang07: {
    agentX: [
      {
        type: "chatInfo_Talk1",
        marType: "mb20",
        text: `
          메모를 발견하니 시스템 메시지가 보인다.
        `,
      },
      {
        type: "ImgOnly",
        marType: "mb20",
        className: "chatFullImg",
        src: s7_itemA,
      },
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "system",
        chat_tit: "시스템",
        talkType: "chat_b_left_Talk4",
        text: `
          [발견된 메모 - 일부 손상]<br/>
          감지된 언어: 독일어<br/>
          Daten um 19: ▢▢ übertragen<br/>
          오후 7시 ▢▢분에 데이터 전송
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          지시사항:<br/>
          파트너의 쪽지와 합쳐 단서를 찾아보세요.<br/> 모든 방향의 숫자가 가리키는 ‘하나의 합’에 주목하세요.
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          Q. 메모에 적힌 시각은?<br/>
          [ __ : __ ]
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "입력 완료",
        isLast: true,
        action: "route",
        route: "/answer",
      },
    ],
    agentY: [
      {
        type: "chatInfo_Talk1",
        marType: "mb20",
        text: `
          메모를 발견하니 시스템 메시지가 보인다.
        `,
      },
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "system",
        chat_tit: "시스템",
        talkType: "chat_b_left_Talk4",
        text: `
          [발견된 메모 - 일부 손상]<br/>
          Daten um ▢▢:▢▢ übertragen<br/>
          ▢▢시 ▢▢분에 데이터 전송
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          지시사항:<br/>
          두 쪽지를 합쳐<br/>
          마방진을 완성하세요.
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          Q. 메모에 적힌 시각은?<br/>
          [ __ : __ ]
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "입력 완료",
        isLast: true,
        action: "route",
        route: "/answer",
      },
    ],
    answer: [
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "Cone",
        chat_tit: "꼬네",
        talkType: "chat_b_left_Talk2",
        text: `
        정답이다냥~!
      `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          정답 : 오후 7시45분
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          완성된 3x3 마방진:<br/>
          18 11 16<br/>
          13 15 17<br/>
          14 19 12<br/>
          각 줄 합 = 45<br/>
          <br/>
          Daten um 19 : 45<br/>
          übertragen<br/>
          오후 7시 45분에 데이터 전송
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          <p class="txtW700 txt44BAD1">단서 획득 #7</p>
          <p class="txtW700">[범행 계획서]</p>
          독일어 메모:<br/>
          "19:45에 데이터 전송"<br/>
          Daten um 19 : 45<br/>
          übertragen
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          결정적인 증거다냥.<br/>
          "19:45에 데이터 전송"이라는 구체적인 계획이 적혀있다냥.<br/>
          독일어를 쓸 수 있는 사람일 가능성이 높다냥.
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          다음 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥.
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "확인",
        isLast: true,
        action: "route",
        route: "/keywordInput",
      },
    ],
  },
  alarm8: {
    agentX: [
      {
        type: "chatInfo_Talk1",
        marType: "mb20",
        text: `
          보안 시스템에 접속하니 시스템 메시지가 보인다.
        `,
      },
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "system",
        chat_tit: "시스템",
        talkType: "chat_b_left_Talk",
        text: `
          [보안 시스템 로그]<br/>
          19:40:03 - [경고] 외부 서버 접속 시도 감지<br/>
          19:42:15 - [알람 해제] 담당자 조치
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          [11월 8일 보안팀 업무 일지]<br/>
          18:00 - 김승우, 서버실 정기 점검 시작<br/>
          18:15 - 박진호, 서버실 정기 점검 시작<br/>
          18:30 - 점검 중 (정상) [담당자 : 박진호 차장, 김승호 사원]
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          [보안팀 직원 증언]<br/>
          “퇴근 시간이 다가오기도 했고,  현장에 늦게 투입되셔서 착각하신 것 같았어요.”
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk4",
        text: `
          Q. 19:42에 알람을 해제한 사람은?
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "입력 완료",
        isLast: true,
        action: "route",
        route: "/answer",
      },
    ],
    agentY: [
      {
        type: "chatInfo_Talk1",
        marType: "mb20",
        text: `
          보안 시스템에 접속하니 시스템 메시지가 보인다.
        `,
      },
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "system",
        chat_tit: "시스템",
        talkType: "chat_b_left_Talk",
        text: `
          [보안 시스템 로그]<br/>
          19:47:28 - [발견] 외부 이메일 전송 기록
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          [11월 8일 보안팀 업무 일지]<br/>
          19:40 - 보안 알람 발생<br/>
          19:42 - 박진호, 알람 확인 후 "오작동" 판단하여 해제
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          [보안팀 직원 증언]<br/>
          차장님이 그렇게 빨리 처리한 건 처음이었어요. 평소엔 30분씩 확인하시는데 말이에요.
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          Q. 19:42에 알람을 해제한 사람은?
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "입력 완료",
        isLast: true,
        action: "route",
        route: "/answer",
      },
    ],
    answer: [
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "Cone",
        chat_tit: "꼬네",
        talkType: "chat_b_left_Talk2",
        text: `
        정답이다냥~!
      `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          정답 : 박진호
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          <p class="txtW700">[사건 재구성]</p>
          19:40:03 - 알람 발생<br/>
          ↓ (2분 12초)<br/>
          19:42:15 - 박진호가 알람 해제<br/>
          ↓ (5분 13초)<br/>
          19:47:28 - 실제 전송 발생!
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          <p class="txtW700 txt44BAD1">단서 획득 #8</p>
          <p class="txtW700">[타임라인 정리]</p>
          19:35 - 파일 접근<br/>
          19:40 - 알람 발생<br/>
          19:42 - 알람 해제<br/>
          19:45 - 계획 시각<br/>
          19:47 - 실제 전송 성공
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          타임라인을 보면 이야기가 보인다냥.<br/>
          19:40에 알람이 발생했고, 박진호가 2분 만에 해제했다냥.<br/>
          박진호는 이 사안을 실수라고 주장한다냥.
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          만약 실수가 아니라면 박진호가 범인이겠다냥. 하지만 정말 실수라면, 그 실수를 누군가 이용했을 가능성이 높다냥.
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          다음 <span class="txtW700">키워드</span>를 찾아 <span class="txtW700">키워드 입력창</span>에 입력하라냥.
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "확인",
        isLast: true,
        action: "route",
        route: "/keywordInput",
      },
    ],
  },
  cross9: {
    agentX: [
      {
        type: "chatInfo_Talk1",
        marType: "mb20",
        text: `
          프로파일링을 시작하니 시스템 메시지가 보인다.
        `,
      },
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "system",
        chat_tit: "시스템",
        talkType: "chat_b_left_Talk",
        text: `
          [범인의 심리 프로파일링]<br/>
          다음 진술 중 진실은?<br/>
          <br/>
          <p class="txtW700">용의자 진술 용의자A:</p>
          “나는 피해자와 사이가 나쁘지 않았습니다.”
          <p class="txtW700">거짓 탐지 기준:</p>
          - 시선 회피 + 손 떨림<br/>
          → 거짓 가능성 ↑
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          <p class="txtW700">행동 기록:</p>
          용의자B - 시선 회피 + 손 떨림 + 숨 고르기 반복<br/>
          용의자C - 말투 안정적, 진술 중 눈동자 움직임 거의 없음
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          Q. 어떤 진술이 거짓인가?<br/>
          용의자 알파벳을 입력하라.
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "입력 완료",
        isLast: true,
        action: "route",
        route: "/answer",
      },
    ],
    agentY: [
      {
        type: "chatInfo_Talk1",
        marType: "mb20",
        text: `
          프로파일링을 시작하니 시스템 메시지가 보인다.
        `,
      },
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "system",
        chat_tit: "시스템",
        talkType: "chat_b_left_Talk",
        text: `
          [용의자 진술]<br/>
          용의자B: “사건 당시 나는 연구실에서 데이터 정리 중이었습니다.”<br/>
          용의자C: “그 시간엔 서버실 점검 중이었어요. CCTV에도 있을 겁니다.”
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          <p class="txtW700">거짓 탐지 기준:</p>
          - 일정한 호흡과 시선 유지 → 진실 가능성 ↑<br/>
          - 과도한 제스처나 방어적 언행 → 자신 방어 심리 ↑
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          <p class="txtW700">행동 기록:</p>
          용의자A - 손을 만지며 “사이 나쁘지 않았다” 반복
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          Q. 어떤 진술이 거짓인가?<br/>
          용의자 알파벳을 입력하라.
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "입력 완료",
        isLast: true,
        action: "route",
        route: "/answer",
      },
    ],
    answer: [
      {
        type: "leftCharacter",
        marType: "mb8",
        chat_icon: "Cone",
        chat_tit: "꼬네",
        talkType: "chat_b_left_Talk2",
        text: `
        정답이다냥~!
      `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk2",
        text: `
          정답 : B(용의자 B)
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          <p class="txtW700">[논리 검증]</p>
          <p class="dotTxt">“연구실에 있었다”는 진술은 부분적으로 사실(연구실 출입 O)이나,</p>
          <p class="dotTxt">19:10~19:30 로그 조작 구간과 겹친다.</p>
          <p class="dotTxt">→ ‘있었다’는 사실이 곧 ‘무죄’는 아님.</p>
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          <p class="txtW700">[심리 분석]</p>
          <p class="dotTxt">용의자B의 행동: 시선 회피 + 손 떨림 + 숨 고르기 반복 → 복합 거짓 신호</p>
          <p class="dotTxt">진술 내용은 “사건 당시 연구실”이지만, 내적 불안과 논리 불일치 공존</p>
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          <p class="txtW700 txt44BAD1">단서 획득 #9</p>
          <p class="txtW700">[용의자B의 행동]</p>
          시선 회피 + 손 떨림 + 숨 고르기 반복 → 복합 거짓 신호<br/>
          <br/>
          진술 내용은 “사건 당시 연구실”이지만, 내적 불안과 논리 불일치 공존.
        `,
      },
      {
        type: "left_txt",
        marType: "mb8",
        talkType: "chat_b_left_Talk",
        text: `
          당시 사건에서 용의자들을 분석해보았다냥. 이제 최종 미션으로 넘어가자냥.
        `,
      },
      {
        type: "button",
        classes: ["inputBtn02", "mt20"],
        id: "btn1",
        label: "확인",
        isLast: true,
        action: "route",
        route: "/keywordInput",
      },
    ],
  },
  final0: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk",
      text: `
        자, 마지막 미션이다냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        지금까지 9개의 단서를 수집했다냥. 이제 이 단서들을 연결해서 진실을 밝힐 시간이다냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb40",
      talkType: "chat_b_left_Talk",
      text: `
        다음 퀴즈에 답하라냥.<br/>
        모든 답을 맞혀야 진실에 도달한다냥!
      `,
    },
    {
      type: "chatInfo_Talk1",
      marType: "",
      text: `
        기억의 조각에서 수집한 단서를 활용하여<br/>
        범인의 이름을 맞추세요.<br/>
        <br/>
        범인의 이름은 무엇일까요?
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "SPY X 추리하기",
      isLast: true,
      action: "route",
      route: "/quiz",
      state: {
        answerData: "end_q1",
        DateVal: "end_q1",
        titImgClass: "quizTit10",
        hintWhetherIs: false,
        hintContent: "",
      },
    },
  ],
  end_q1: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: `
        수집한 단서를 바탕으로 답하세요.<br/>
        각 질문당 10점, 총 60점 만점
      `,
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `
        Q1. 범인이 사용한 외국어는?
        <p class="indentTxt">1. 영어</p>
        <p class="indentTxt">2. 독일어</p>
        <p class="indentTxt">3. 중국어</p>
        <p class="indentTxt">4. 스페인어</p>
        <p class="indentTxt">5. 프랑스어</p>
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `
        정답을 숫자로 입력하세요.
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "입력 완료",
      isLast: true,
      action: "route",
      route: "/quiz",
      state: {
        answerData: "end_q2",
        DateVal: "end_q2",
        titImgClass: "quizTit10",
        hintWhetherIs: false,
        hintContent: "",
      },
    },
  ],
  end_q2: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: `
        수집한 단서를 바탕으로 답하세요.<br/>
        각 질문당 10점, 총 60점 만점
      `,
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `
        Q2. 범인이 파일을 접근한 시간은?
        <p class="indentNum">1. 18:30</p>
        <p class="indentNum">2. 18:45</p>
        <p class="indentNum">3. 19:35</p>
        <p class="indentNum">4. 20:00</p>
        <p class="indentNum">5. 22:00</p>
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `
        정답을 숫자로 입력하세요.
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "입력 완료",
      isLast: true,
      action: "route",
      route: "/quiz",
      state: {
        answerData: "end_q3",
        DateVal: "end_q3",
        titImgClass: "quizTit10",
        hintWhetherIs: false,
        hintContent: "",
      },
    },
  ],
  end_q3: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: `
        수집한 단서를 바탕으로 답하세요.<br/>
        각 질문당 10점, 총 60점 만점
      `,
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `
        Q3. 실제 데이터 전송 시각은? <br/>
        (메모에 적힌 시각 기준)
        <p class="indentNum">1. 19:35</p>
        <p class="indentNum">2. 19:40</p>
        <p class="indentNum">3. 19:42</p>
        <p class="indentNum">4. 19:45</p>
        <p class="indentNum">5. 19:47</p>
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `
        정답을 숫자로 입력하세요.
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "입력 완료",
      isLast: true,
      action: "route",
      route: "/quiz",
      state: {
        answerData: "end_q4",
        DateVal: "end_q4",
        titImgClass: "quizTit10",
        hintWhetherIs: false,
        hintContent: "",
      },
    },
  ],
  end_q4: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: `
        수집한 단서를 바탕으로 답하세요.<br/>
        각 질문당 10점, 총 60점 만점
      `,
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `
        Q4. 범인이 혼자 남아있던 장소는?
        <p class="indentNum">1. 회의실</p>
        <p class="indentNum">2. 연구실</p>
        <p class="indentNum">3. 서버실</p>
        <p class="indentNum">4. 인사팀 사무실</p>
        <p class="indentNum">5. 카페테리아</p>
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `
        정답을 숫자로 입력하세요.
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "입력 완료",
      isLast: true,
      action: "route",
      route: "/quiz",
      state: {
        answerData: "end_q5",
        DateVal: "end_q5",
        titImgClass: "quizTit10",
        hintWhetherIs: false,
        hintContent: "",
      },
    },
  ],
  end_q5: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: `
        수집한 단서를 바탕으로 답하세요.<br/>
        각 질문당 10점, 총 60점 만점
      `,
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `
        Q5. 범행을 가능하게 만든 결정적 사건은?
        <p class="indentNum">1. 김현수의 파일 열람</p>
        <p class="indentNum">2. 박진호의 알람 해제</p>
        <p class="indentNum">3. 최민아의 정보 제공</p>
        <p class="indentNum">4. 정우석의 외부 연결</p>
        <p class="indentNum">5. 야근 허가</p>
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `
        정답을 숫자로 입력하세요.
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "입력 완료",
      isLast: true,
      action: "route",
      route: "/quiz",
      state: {
        answerData: "end_q6",
        DateVal: "end_q6",
        titImgClass: "quizTit10",
        hintWhetherIs: false,
        hintContent: "",
      },
    },
  ],
  end_q6: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: `
        수집한 단서를 바탕으로 답하세요.<br/>
        각 질문당 10점, 총 60점 만점
      `,
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `
        Q6. 범인의 긴장 습관으로 남은 흔적은?
        <p class="indentNum">1. 안경 자국</p>
        <p class="indentNum">2. 손톱 부스러기</p>
        <p class="indentNum">3. 구겨진 종이</p>
        <p class="indentNum">4. 발자국</p>
        <p class="indentNum">5. 턱 자국</p>
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `
        정답을 숫자로 입력하세요.
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "입력 완료",
      isLast: true,
      action: "route",
      route: "/quiz",
      state: {
        answerData: "last_q",
        DateVal: "last_q",
        titImgClass: "quizTit10",
        hintWhetherIs: false,
        hintContent: "",
      },
    },
  ],
  last_q: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: `
        퀴즈 점수: {{finalQuizScore}}점 / 60점
      `,
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk",
      text: `
        이제 마지막 질문이다냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        모든 단서와 퀴즈 답을 종합해서... 진짜 스파이 X가 누구인지 추론하라냥!
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `
        최종 질문:<br/>
        스파이 X는 누구입니까?
        <p class="indentTxt">A. 김현수</p>
        <p class="indentTxt">B. 이지은</p>
        <p class="indentTxt">C. 박진호</p>
        <p class="indentTxt">D. 최민아</p>
        <p class="indentTxt">E. 정우석</p>
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "입력 완료",
      isLast: true,
      action: "route",
      route: "/answer",
    },
  ],
  last_answer: [
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk",
      text: `
        모든 단서가 한 사람을 가리키고 있었다냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        ✓ 독일어 능력 (유일)<br/>
        ✓ 19:35 ~ 45분 접근<br/>
        ✓ 네일아트샵 방문<br/>
        ✓ 22:00까지 혼자 잔류<br/>
        ✓ 18회 야근 (계획 준비)<br/>
        ✓ 1주일 전 감정 변화 (결심)<br/>
        ✓ 프로젝트 제외 (동기)
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        <p class="txtW700">🏆 최종 점수</p>
        퀴즈 점수: <span class="txtW700 txt44BAD1">{{finalQuizScore}}</span>점 / 60점<br/>
        범인 특정: {{suspectScore}}점<br/>
        ─────────<br/>
        총점: <span class="txtW700 txt44BAD1">{{totalQuizScore}}</span>점 / 80점<br/>
        클리어 시간: <span class="txtW700 txt44BAD1">{{clearTime}}</span>
      `,
    },
    {
      type: "button",
      label: "사건의 전말 보기",
    },
  ],
  finish: [
    {
      type: "chatInfo_Talk1",
      marType: "mb20",
      text: "📌 배경 & 동기",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `
        <p class="txtW700">범인: 이지은 (연구개발팀 대리)</p>
        이지은은 1년간 독일 본사에 파견되어 회사 핵심 기술을 연구했습니다.  귀국 후 승진과 인정을 기대했으나, 신규 프로젝트 'Project NAPI'에서 이유 없이 배제되었습니다.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        "내 능력을 증명하고 싶다.", "회사가 나를 무시한다."<br/>
        이런 생각이 점점 커지면서, 3주 전 극단적인 결심을 하게 됩니다.
      `,
    },
    {
      type: "chatInfo_Talk1",
      marType: "mb20 mt40",
      text: "📅 범행 준비 과정",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `
        [3주 전]<br/>
        심리 상담을 갑자기 취소. "더 이상 대화로는 안 된다"<br/>
        → 다른 방법을 찾기로 결심
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        [2주 전]<br/>
        야근을 급격히 늘림 (18회/월). 혼자 남는 시간을 만들며 계획 수립. 회사 보안 시스템 취약점 파악.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        [1주일 전]<br/>
        계획이 완성되자 표정이 밝아짐. 동료들이 이상하게 여길 정도.<br/>
        독일어로 메모 작성 - 발각 방지.
      `,
    },
    {
      type: "chatInfo_Talk1",
      marType: "mb20 mt40",
      text: "🎬 범행 당일 (상세 타임라인)",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `
        [18:50]<br/>
        연구실 출근. 커피 3잔 준비 (각성).
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        [19:35]<br/>
        Project NAPI 파일 접근 시작. 프로젝트에서 제외됐지만 권한은 유지. 손톱을 물어뜯으며 극도로 긴장. 45분간 파일 분석 및 복사.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        [19:40]<br/>
        외부 서버로 전송 시도. → 보안 알람 발생!<br/>
        <br/>
        [같은 시각, 서버실]<br/>
        박진호가 정기 점검 중 알람 확인. 퇴근 시간이 다가오자 성급하게 판단.<br/>
        "시스템 오작동"으로 착각.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        [19:42]<br/>
        박진호가 알람 해제. 완벽주의자의 평생 첫 실수. → 이지은에게 기회 제공
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        [19:45]<br/>
        알람이 해제되자 메모대로 진행. "Daten um 19:45<br/>
        übertragen" (19:45에 데이터 전송)
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        [19:47]<br/>
        외부 이메일로 기밀 파일 전송 성공.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        [20:20]<br/>
        모든 동료 퇴근.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        [20:20 ~ 22:00]<br/>
        혼자 남아 흔적 정리.<br/>
        - 전송 기록 일부 삭제<br/>
        - 독일어 메모 서랍 깊숙이 숨김<br/>
        - 하지만 손톱 부스러기는 미처 발견 못함<br/>
        <br/>
        [22:00] 퇴근.
      `,
    },
    {
      type: "chatInfo_Talk1",
      marType: "mb20 mt40",
      text: "🔍 발각 과정",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `
        다음날 아침: <br/>
        외부 전송 흔적 발견, 수사 시작.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        발견된 결정적 증거들:
        <p class="indentNum">1. 독일어 메모 (서랍 속) → 5명 중 이지은만 독일어 능숙</p>
        <p class="indentNum">2. 19:47 전송 시각 → 메모의 19:45와 일치</p>
        <p class="indentNum">3. 45분 부당 접근 → 프로젝트 제외 상태인데 접근</p>
        <p class="indentNum">4. 연구실 손톱 부스러기 → 이지은의 긴장 습관으로 알려져 있으나, 이 습관을 이용하여 의심받지 않고 네일아트샵에 감.</p>
        <p class="indentNum">5. 3주간 계획적 변화 → 우발적이 아닌 치밀한 범행</p>
      `,
    },
    {
      type: "chatInfo_Talk1",
      marType: "mb20 mt40",
      text: "👥 다른 용의자들의 진실",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk",
      text: `
        김현수: 승진 탈락 불만은 있었으나 건강하게 대처 중. 범행 무관.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        박진호: 완벽주의자의 첫 실수. 나중에 깨닫고 자책 (종이 5장 구김). 공모자가 아닌 실수한 사람.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        최민아: 11월 인사평가로 야근 12회. 정당한 업무. 범행 무관.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        정우석: 경쟁사 접촉은 평소 인맥 관리. 의심스러워 보였지만 정상 업무. 범행 무관.
      `,
    },
    {
      type: "chatInfo_Talk1",
      marType: "mb20 mt40",
      text: "⚖️ 결론",
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "system",
      chat_tit: "시스템",
      talkType: "chat_b_left_Talk2",
      text: `
        범인: 이지은
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `
        동기:<br/>
        - 프로젝트 제외에 대한 불만<br/>
        - 인정 욕구 충족 실패
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `
        방법:<br/>
        - 3주간 치밀한 계획<br/>
        - 박진호의 실수 악용
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `
        증거:<br/>
        - 독일어 능력 (유일)<br/>
        - 시간대 정확 일치<br/>
        - 현장 흔적 일치
      `,
    },
    {
      type: "leftCharacter",
      marType: "mb8",
      chat_icon: "Cone",
      chat_tit: "꼬네",
      talkType: "chat_b_left_Talk2",
      text: `
        훌륭한 추리였다냥!
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        처음엔 5명 모두 의심스러웠다냥. 김현수의 불만, 박진호의 5분 지각, 최민아의 야근, 정우석의 경쟁사 접촉...
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        하지만 단서들을 하나씩 모으며 진실이 드러났다냥.
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        결정적이었던 것들:<br/>
        ✓ 독일어 메모 (이지은만 가능)<br/>
        ✓ 19:45 시간 (계획된 범행)<br/>
        ✓ 45분 접근 (부당)<br/>
        ✓ 손톱 부스러기 (습관)<br/>
        ✓ 감정 변화 (결심)
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk",
      text: `
        추리에서 가장 중요한 건:
        <p class="indentNum">1. 단서를 빠짐없이 수집</p>
        <p class="indentNum">2. 섣불리 판단하지 않기</p>
        <p class="indentNum">3. 모든 단서를 종합해 결론</p>
      `,
    },
    {
      type: "left_txt",
      marType: "mb8",
      talkType: "chat_b_left_Talk2",
      text: `
        두 사람은 훌륭한 탐정이다냥!
      `,
    },
    {
      type: "button",
      classes: ["inputBtn02", "mt20"],
      id: "btn1",
      label: "방탈출 인증서 확인하기",
      isLast: true,
      action: "route",
      route: "/ranking",
    },
  ],
};
